import { breakpoints, getScreenSize } from "./components/variables";
import { convertTranslationLabels } from "./components/translations";
import Choices from "choices.js";
import HeroSlider from './components/heroSlider';

(function($) {

  /**
   * Hide This Page Button
   * Redirect to Google and replace the current page in history
   */
  const $hideBtn = $('#hidePageBtn');
  $hideBtn.on('click', function() {
    window.location.replace("https://www.google.com");
  });


  /**
   * Fix Translation Labels
   */
  convertTranslationLabels();


  /**
   * Select Dropdowns
   */
  const $selects = $('select');
  $selects.each(function(){
      const $select = $(this);

      // Handle tab selects only on mobile
      if ( $(this).hasClass('bde-tabs__select') && window.innerWidth > breakpoints.portraitTablet ) {
          return;
      }

      // Don't target woocommerce selects, those are already using Select2
      const $woocommerceWrapper = $(this).parents('.woocommerce-input-wrapper');
      if ( $woocommerceWrapper.length ) {
        return;
      }

      const selectChoice = new Choices($(this)[0], {
          allowHTML: true,
          searchEnabled: false,
          shouldSort: false,
          itemSelectText: '',
          callbackOnInit: function(){
            // Ensure the dropdown is fully connected to any additional JS, such as with WooCommerce
            setTimeout(function() {
              selectChoice.refresh();
            }, 1000);
          }
      });

      selectChoice.passedElement.element.addEventListener(
        'choice',
        function(event) {
          setTimeout(function() {
            selectChoice.refresh();
          }, 300);
        },
        false,
      );


      /**
       * Select Job Application position
       */
      if ( $select.attr('id', 'field_jobposition') ) {
        const $jobBtns = $('.breakdance-link[data-job-position]');
        $jobBtns.on('click', function(){
          const name = $(this).data('job-position') ? $(this).data('job-position') : null;
          if ( !name ) return;
          selectChoice.setChoiceByValue(name);
          $select.trigger('change');
        });
      }

  });



	/**
   * Hero Sliders
   */
	const $heroSliders = $('.heroSlider');
	if ( $heroSliders.length ) {
		$heroSliders.each(function(){
			const slider = new HeroSlider($(this));
			slider.init();
		});
	}


	
	/**
	 * Form Tooltip Descriptions
	 */
  const $fieldsWithTooltip = $('.field--tooltipDescription');
  $fieldsWithTooltip.each(function(){
      const $description = $(this).find('.frm_description');
      const $label = $(this).find('.frm_primary_label');
      $description.hide();
      $label.on('click', function(){
        $description.slideToggle();
      });
  });

  
  /**
   * Zakat Calculator: Add total to Donate button's amount
   */
  const $zakatTotalField = $('#field_zakattotal');
  const $zakatDonateBtn = $('#zakatDonateBtn');
  $zakatTotalField.on('change', function(){
    const total = $(this).val();
    const url = $zakatDonateBtn.data('url-start') + '&amount=' + total;
    $zakatDonateBtn.attr('href', url);
  });


})( jQuery );
